import React from "react";
import { Row, Col ,MenuItem ,DropdownButton ,ButtonToolbar,Button,Grid,ToggleButtonGroup,ToggleButton } from 'react-bootstrap'
import ProductItemGrid from "../ProductItemGrid/ProductItemGrid";
import Paginations from "../Paginations/Paginations";
import PopularProducts from "../PopularProducts/PopularProducts";

class GridProducts extends React.Component {
render() {
return (
    <div className="GridProducts">
      
         

            <Row>
              <Col md={4}>
       <ProductItemGrid/>
       
       </Col>


          <Col md={4}>
       <ProductItemGrid/>
       
       </Col>

          <Col md={4}>
       <ProductItemGrid/>
       
       </Col>

          <Col md={4}>
       <ProductItemGrid/>
       
       </Col>
      

         <Col md={4}>
       <ProductItemGrid/>
       
       </Col>
      
       <Col md={4}>
       <ProductItemGrid/>
       
       </Col>
      
       <Col md={4}>
       <ProductItemGrid/>
       
       </Col>
      
       <Col md={4}>
       <ProductItemGrid/>
       
       </Col>
      
       <Col md={4}>
       <ProductItemGrid/>
       
       </Col>
      
       <Col md={4}>
       <ProductItemGrid/>
       
       </Col>
      

         <Col md={4}>
       <ProductItemGrid/>
       
       </Col>
       <Col md={4}>
       <ProductItemGrid/>
       
       </Col>
      
       
       
       

        
        </Row>


    

</div>
);
}
}
export default GridProducts;


// WEBPACK FOOTER //
// ./src/Components/GridProducts/GridProducts.jsx